<template>
  <b-row>
    <b-col
      cols="12"
      lg="6"
      class="align-items-start"
    >
      <b-card class="scan-order-form">
        <h5 class="py-1 text-center scan-order-header">
          SCAN ORDER
        </h5>
        <div class="align-items-center px-2 pt-1">
          <!-- 1. Scan Input (flex: 3) -->
          <div
            class="mb-2"
          >
            <b-form-group label="Scan Order">
              <b-input-group>
                <b-form-input
                  v-model="scanCode"
                  class="scan-out"
                  placeholder="Scan Order Here"
                  @keyup.enter="triggerScan"
                />
                <b-input-group-append>
                  <b-button
                    class="barcode"
                    @click="triggerScan"
                  >
                    <img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1zZWFyY2gtaWNvbiBsdWNpZGUtc2VhcmNoIj48cGF0aCBkPSJtMjEgMjEtNC4zNC00LjM0Ii8+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjwvc3ZnPg==">
                  </b-button>
                </b-input-group-append>
              <!-- <b-col cols="auto">
                  <WaybillSearch
                    :waybill-number="form.waybill_number"
                    @search="getOrderDetails(form.waybill_number)"
                  />
                </b-col> -->
              </b-input-group>
            </b-form-group>
          </div>
          <!-- 1. Scan Input (flex: 3) -->
          <div
            class="mb-2"
          >
            <b-form-group label="Scan Result">
              <b-input-group>
                <b-form-input
                  v-model="scanMsg"
                  class="scan-out"
                  placeholder="Scan Result"
                  disabled
                  :style="resultInputStyle"
                />
              </b-input-group>
            </b-form-group>
          </div>
        </div>
      </b-card>
    </b-col>
    <b-col
      cols="12"
      lg="6"
      class="align-items-start"
    >
      <b-card
        class="flex-fill scan-order-card"
        :style="{ '--bucket-bg-color': bucketColor ? bucketColor : rgba(115, 103, 240, 0.2) }"
      >
        <div
          class="d-flex align-items-center"
          :class="scanStatus ? 'justify-content-center' : 'justify-content-center'"
        >
          <h4
            v-if="scanStatus === 1|| scanStatus === 0"
            class="text-primary scanned-order px-1"
          >
            {{ location || 'Error...' }}
          </h4>
          <h4
            v-if="scanStatus === -1"
            class="text-primary scanned-order px-1"
          >
            {{ location || 'Waiting...' }}
          </h4>
          <span
            v-if="scanStatus === 1"
            class="text-primary status-emoji"
          >☑️</span>
          <span
            v-else-if="scanStatus === 0"
            class="text-danger status-emoji"
          >❌</span>
        </div>
      </b-card>
      <b-card
        class="flex-fill scan-order-card"
        :style="{ '--bucket-bg-color': bucketColor ? bucketColor : rgba(115, 103, 240, 0.2) }"
      >
        <div class="text-center path">
          <div
            v-if="fullPath.length"
            class="d-flex flex-wrap justify-content-center"
          >
            <span
              v-for="(node, index) in fullPath"
              :key="index"
              class="d-flex node-wrapper"
            >
              <div
                class="path-node"
                :style="{ backgroundColor: darkerBucketColor }"
              >{{ node.name }}</div>
              <span v-if="index < fullPath.length - 1">→</span>
            </span>
          </div>
          <div
            v-if="!fullPath.length"
            class="no-path"
          >
            Scan an order to view its delivery path
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BInputGroup, BFormInput, BButton, BInputGroupAppend, BCol, BRow, BFormGroup,
} from 'bootstrap-vue'
import { integer } from 'vee-validate/dist/rules'

export default {
  components: {
    BCard,
    BInputGroup,
    BFormInput,
    BButton,
    BCol,
    BRow,
    BFormGroup,
    BInputGroupAppend,
  },
  props: {
    location: {
      type: String,
      required: true,
    },
    fullPath: {
      type: Array,
      required: true,
    },
    bucketColor: { type: String, default: '#7367F0' }, // default color
    scanStatus: { type: integer, default: -1 }, // 'success' | 'error' | ''
    scanMsg: { type: String, default: '' },
  },
  data() {
    return {
      scanCode: '',
      scanCounter: 0,
    }
  },
  computed: {
    resultInputStyle() {
      if (this.scanStatus === 1) {
        return { backgroundColor: '#d4edda' } // light green for success
      }
      if (this.scanStatus === 0) {
        return { backgroundColor: '#f8d7da' } // light red for error
      }
      return { backgroundColor: '#ffffff' } // default white
    },
    darkerBucketColor() {
    // Convert rgba or hex to RGB, then darken
      const parseColor = color => {
        const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/)
        const hexMatch = color.match(/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i)
        if (rgbaMatch) {
          return rgbaMatch.slice(1, 4).map(Number)
        } if (hexMatch) {
          return hexMatch.slice(1, 4).map(hex => parseInt(hex, 16))
        }
        return [115, 103, 240] // fallback
      }

      const darken = (rgb, percent = 20) => rgb.map(c => Math.max(0, Math.floor(c * (1 - percent / 100))))

      const [r, g, b] = darken(parseColor(this.bucketColor || 'rgba(115, 103, 240, 1)'))

      return `rgb(${r}, ${g}, ${b})`
    },
  },
  watch: {
    scanCounter() {
      this.scanCode = ''
    },
  },
  methods: {
    triggerScan() {
      this.$emit('scan', this.scanCode)
      this.scanCounter += 1
    },
  },
}
</script>
<style>
.scanned-order {
  font-size: 5rem;
  font-weight: bolder;
  color: white !important;
  text-shadow: 1px 1px 2px black;
  margin-bottom: 0 !important;
}
.path {
  font-size: 1.5rem;
  font-weight: bolder;
  color: white !important;
  text-shadow: 1px 1px 2px black;
}
.scan-order-header {
    color: #000000 !important;
    background-color: rgba(115, 103, 240, 0.2);
    border-radius: 0.5rem 0.5rem 0 0;
    font-weight: 700;
}
.scan-order-form .card-body {
    padding: 0 !important;
}
.barcode {
    background-color: #7367F0 !important;
    border-color: rgb(115, 103, 240) !important;
    padding: 0 5px 0 5px !important;
    width: fit-content !important;
}
.barcode:enabled {
    background-color: #7367F0 !important;
}
.scan-code-input {
  border-right: none !important;
  border-color: rgb(115, 103, 240) !important;
}
.scan-code-input::placeholder {
  color: rgb(115, 103, 240) !important;
}
.scan-order-card {
  --bucket-bg-color:rgba(115, 103, 240, 0.2); /* default fallback */
  background-color: var(--bucket-bg-color) !important;
}
.scan-cards {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 38rem; /* Match Process Order height roughly */
}
.scan-cards .scan-order-card {
  flex: 1 1 50%;
  margin-bottom: 1rem;
}
.bucket-color-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
}
.status-emoji {
  font-size: 3.5rem;
}
.icon-wrapper {
  border-radius: 50%;
  padding: 1rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: white;
}

.blinking-icon {
  animation: blink 1s infinite;
}

.path-node {
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 0.5rem;
  font-weight: 600;
  text-shadow: 1px 1px 2px black;
}

.node-wrapper {
  margin: 3px 0 3px 0;
}

.no-path {
  font-size: 27px;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}
</style>
